import { useEffect, useState } from 'react';
import '../styles/Header.css';
import logo from '../assets/GBLogo2.png'

export default function Header() {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const onScroll = () => setHide(window.scrollY > 80);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header ${hide ? 'hide' : ''}`}>
      <img src={logo} alt="Inversiones Serrano 93" />
    </header>
  );
}